export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./kbNav.vue?vue&type=template&id=036877db&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/kbNav.vue?vue&type=template&id=036877db&
// module id = null
// module chunks = 